<template>
    <div class="module-layer3">
        <div class="layer-cnt">
            <div class="lr-cnt">
                <div class="title"></div>
                <div class="bg-role-name"></div>

                <div class="progress-line" v-if="preview < 100000">
                    <img src="../../assets/img/layer3/default.png" alt="" srcset="">
                </div>
                <div v-else>
                    <div class="progress-line" v-for="(value, fKey) in previewList" :key="fKey"
                        :class="['item' + (fKey + 1), (preview >= value && ((fKey + 1) === previewList.length || preview < previewList[fKey + 1])) ? 'pimg-block' : 'pimg-none',]">
                        <img :src="require('../../assets/img/layer3/d-' + (fKey + 1) + '.png')" alt="" srcset="">
                    </div>
                </div>
            </div>
            <div class="bg-role"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'app',
    data() {
        return {
            preview: 0,
            previewList: [100000, 200000, 300000, 400000, 500000,], // 卡片
        }
    },
    watch: {
    },


}
</script>
<style lang="scss" scoped>
.module-layer3 {
    width: 100%;
    height: 100%;
    position: relative;
    background: url('../../assets/img/layer3/bg.png') 50% no-repeat;
    background-size: cover;

    .layer-cnt {
        width: 100%;
        height: 100%;

        .bg-role {
            background-image: url("../../assets/img/layer3/bg-role.png");
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            width: 750px;
            height: 1186px;
            position: absolute;
            top: 0;
            z-index: 0;
        }

        .lr-cnt {
            position: relative;
            z-index: 1;
            width: 100%;
            height: 100%;

            .title {
                background-image: url("../../assets/img/layer3/title.png");
                background-position: center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                width: 352px;
                height: 214px;
                position: absolute;
                top: 7%;
                left: 50%;
                transform: translate(-50%, 0);
            }

            .bg-role-name {
                background-image: url("../../assets/img/layer3/bg-role-name.png");
                background-position: center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                width: 124px;
                height: 276px;
                position: absolute;
                top: 32%;
                right: 50px;
            }

            .pimg-block {
                display: block;
            }

            .pimg-none {
                display: none;
            }

            .progress-line {
                width: 700px;
                height: 283px;

                position: absolute;
                bottom: 10%;
                left: 50%;
                transform: translate(-50%, 0);

                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                }

            }
        }
    }


}


@media screen and (min-width: 638px) and (max-width: 1024px) and (orientation : portrait) {
    .module-layer3 {
        .bg-role {
            top: -15% !important;
        }
        .lr-cnt {
            .title {
                width: 252px !important;
                height: 154px !important;
                top: 7% !important;

            }
            .bg-role-name{
                width: 94px !important;
                height: 198px !important;
                right: 32px !important;
            }
        }
        .progress-line {
                width:504px !important;
                height: 204px !important;
                bottom: 8% !important;
        }
    }

}

@media screen and (min-width: 375px) and(max-width: 429px) and (orientation : portrait) {
    .module-layer3 {
        .bg-role {
         
            // left: 0 !important;
            top: -6% !important;
        }
        .lr-cnt {
            .title {
                width: 316px !important;
                height: 192px !important;
                top: 6% !important;

            }
            .bg-role-name{
                width: 117px !important;
                height: 248px !important;
                right: 32px !important;
            }
        }
        .progress-line {
                width:630px !important;
                height: 255px !important;
        }
    }

}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/layer3.vue